import { LoggerFactory } from '@cbre/logger';

const logger = LoggerFactory.getLogger();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function evaluateParserResult(val: string): (obj: Record<string, any>) => boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (obj: Record<string, any>) {
    logger.debug(`${val} ${JSON.stringify(obj)}`);
    // eslint-disable-next-line no-new-func
    return new Function('obj', `return ${val};`)(obj);
  };
}
